import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { initializePromotion } from '../model/configuratorSlice';
import { EndPoints } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';

export default function LoadConfigurationUnitService() {
    const { promotionSlug, currentUnit } = useSelector(state => state.configurator);
    const dispatch = useDispatch();

    return useMutation(['loadConfigurationUnitQuery'], () => {
        const currentUnitCode = currentUnit !== null ? currentUnit.id : 0;
      // eslint-disable-next-line max-len
        const loadConfigUnitUrl = `${EndPoints.LoadConfigUnitUrl}/${promotionSlug}/unit/${currentUnitCode}/configuration`;

        axios
            .get(loadConfigUnitUrl)
            .then((response) => {
                dispatch(initializePromotion(response.data));
            })
            .catch((error) => {
                // dispatch(setSnackbarMessage(FeedbackMessages.ConfigurationCodeNotFound));
            });
    });
}
